// src/pages/Users/ArbitrageJudo/ArbitrageJudo.jsx

import React from "react";
import { FaGavel } from "react-icons/fa";

import { useUser } from "./../../Home/UserContext";
import { getRoleFromRoleId } from "./../../../utils/roleHelper";

import DashboardNavigation from "./../../DashboardNavigation/DashboardNavigation";
import useScrollToTop from "./../../../hooks/useScollToTop";
import ScrollIndicator from "./../../Home/ScrollIndicator";
import HeaderTitle from "../../../components/HeaderTitle/HeaderTitle";
import Reveal from "./../../../components/Reveal/Reveal";

import ArbitrageHero from "./components/ArbitrageHero";
import ArbitrageQuickNav from "./components/ArbitrageQuickNav";
import ArbitrageSection from "./components/ArbitrageSection";

import { ARBITRAGE_SECTIONS } from "./data/arbitrageJudoData";

export default function ArbitrageJudo() {
  useScrollToTop();

  const { user } = useUser();
  const userRole = getRoleFromRoleId(user?.role_id);

  return (
    <section className="min-h-screen bg-slate-50 text-slate-950 dark:bg-slate-950 dark:text-slate-50">
      <ScrollIndicator />

      <div className="pt-[96px] sm:pt-[120px] lg:pt-[160px]" aria-hidden />

      <main className="mx-auto w-full max-w-7xl px-3 pb-24 sm:px-6 lg:px-8">
        <HeaderTitle
          role="Utilisateur"
          title="Arbitrage Judo"
          subtitle="Comprendre les gestes, les scores, les pénalités et les règles essentielles pour suivre ou pratiquer en compétition."
          icon={FaGavel}
          align="left"
          className="mb-4"
        />

        <div className="mb-4">
          <DashboardNavigation role={userRole} />
        </div>

        <Reveal>
          <ArbitrageHero />
        </Reveal>

        <div className="sticky top-[76px] z-30 -mx-3 mt-4 border-y border-slate-200/80 bg-slate-50/95 px-3 py-3 backdrop-blur-xl dark:border-slate-800 dark:bg-slate-950/90 sm:static sm:mx-0 sm:border-0 sm:bg-transparent sm:px-0 sm:py-0 sm:backdrop-blur-0">
          <ArbitrageQuickNav sections={ARBITRAGE_SECTIONS} />
        </div>

        <div className="mt-5 space-y-5">
          {ARBITRAGE_SECTIONS.map((section, index) => (
            <Reveal key={section.id}>
              <ArbitrageSection section={section} index={index} />
            </Reveal>
          ))}
        </div>
      </main>
    </section>
  );
}